export class NavigationAction {
  params: {} | null = null;
  url: string[] | null = null;
}
